import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { API_ROUTES } from '../../util/route.constants';
import { TemplateListing, iconMapping } from '../../models/manage-template.interface';
import { ITemplateList, TAB_ITEM } from '../../models/template.model';



@Injectable({
  providedIn: 'root'
})
export class NoteTemplateListingService {
  FAV_TITLE = "Favorites";

  constructor(private readonly http: HttpClient) { }
  getTemplates(): Observable<{ success: boolean }> {
    return this.http.get<{ success: boolean }>(`${environment.cva_url}/${API_ROUTES.NOTE_TEMPLATES}`)
  }

  groupTemplatesByCategoryAndFavorites(items: TemplateListing[]): ITemplateList[] {
    const grouped = items.reduce((acc: { [key: string]: ITemplateList }, item) => {
      // If the item is starred, add it to the "Favorites" category
      if (item.starred) {
        if (!acc[this.FAV_TITLE]) {
          acc[this.FAV_TITLE] = {
            category: this.FAV_TITLE as "Favorites",
            items: []
          };
        }
        acc["Favorites"].items.push({
          name: item.name as TAB_ITEM,
          description: item.description,
          identifier: item.identifier,
          icon: iconMapping[item.category],
          starred: item.starred,
          isCustomTemplate: item.isCustomTemplate
        });
      } else {
        // If the category doesn't exist in the accumulator, initialize it
        if (!acc[item.category]) {
          acc[item.category] = {
            category: item.category,
            items: []
          };
        }

        // Push the item to the corresponding category's items array
        acc[item.category].items.push({
          name: item.name as TAB_ITEM,
          description: item.description,
          identifier: item.identifier,
          icon: iconMapping[item.category],
          starred: item.starred,
          isCustomTemplate: item.isCustomTemplate
        });
      }

      return acc;
    }, {});

    // Convert the object into an array and put the "Favorites" category at the top
    const groupedArray: ITemplateList[] = Object.values(grouped).map(group => ({
      ...group,
      items: [...group.items].sort((a, b) =>
        a.name.toLowerCase().localeCompare(b.name.toLowerCase())
      )
    }));

    groupedArray.sort((a, b) =>
      a.category.toLowerCase().localeCompare(b.category.toLowerCase())
    );
    const favorites = groupedArray.find(group => group.category === this.FAV_TITLE);
    if (favorites) {
      // Remove "Favorites" from its current position and move it to the front
      groupedArray.splice(groupedArray.indexOf(favorites), 1);
      groupedArray.unshift(favorites);  // Add it to the top
    }

    return groupedArray;
  }
}
